export default __webpack_public_path__ + "static/media/NewBillCloseoff.9d7a578d.svg";